enum FinalSalaryType
{
    Standard = 0,
    BridgingPension = 1
}

export default FinalSalaryType;
